import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable()
export class HttpClient {

	private token: string;
	constructor(private http: Http, private localStorage: LocalStorageService) {}

	getSimple(url){
		return this.http.get(url);
	}

	get(url:string, hdrs?:Object) {
		let headers = new Headers();
		if( hdrs )
			for(var h in hdrs) headers.append(h, hdrs[h]);
		let user:any = this.localStorage.get('user');
		if( user && user.token  )
			headers.append('Authorization', 'Basic '+user.token);
		return this.http.get(url, {
			headers: headers
		});
	}

	post(url:string, data:any) {
		let headers = new Headers();
		let user:any = this.localStorage.get('user');
		if( user && user.token  )
			headers.append('Authorization', 'Basic '+user.token);
		return this.http.post(url, data, {
			headers: headers
		});
	}

	put(url:string, data:any) {
		let headers = new Headers();
		let user:any = this.localStorage.get('user');
		if( user && user.token  )
			headers.append('Authorization', 'Basic '+user.token);
		return this.http.put(url, data, {
			headers: headers
		});
	}

	delete(url:string, data?:any) {
		let headers = new Headers();
		let user:any = this.localStorage.get('user');
		if( user && user.token  )
			headers.append('Authorization', 'Basic '+user.token);
		return this.http.delete(url, {
			headers: headers,
			body : data
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/_services/http.client.ts